import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import { useParams } from 'react-router-dom';
import ApiServices from '../../../Utils/ApiServices/ApiServices';

const ServicesForms = ({ formType, formData,appointmentData }) => {
  console.log("formData",formData)
  const [formValues, setFormValues] = useState({});
  const [patientData, setPatientData] = useState(null);

  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();
  const params = useParams();

  const uuid = params.uuid || appointmentData?.pc_uuid;
  
  // Define non-editable fields
  const nonEditableFields = ['patient_name','fname_lname','email','address','city','state','zip','dob','DOB','contact','phone_contact','date_signature','date_representative_signature',"patient_date_of_signature","street","postal_code"];

  useEffect(() => {
    const fetchPatientDetails = async () => {
      try {
        const response = await ApiServices.get(`/apis/default/api/patient/${uuid}`, {
          Authorization: `Bearer ${accessToken}`,
        });

        if (response && response.data && response.data.data) {
          setPatientData(response.data.data);
        }
      } catch (err) {
        console.log(err.message || 'Something went wrong');
      }
    };

    fetchPatientDetails();
  }, [uuid]);

  let formJson = null;
  let filledFormData = null;
  switch (formType) {
    case 'Pre Treatment':
      formJson = formData?.pre_treatment_json ? JSON.parse(formData.pre_treatment_json) : null;
      filledFormData = formData?.filled_pretreatment_form_data || null;
      break;
    case 'Consent Treatment':
      formJson = formData?.consent_treatment_json ? JSON.parse(formData.consent_treatment_json) : null;
      filledFormData = formData?.filled_consent_form_data || null;
      break;
    case 'Post Treatment':
      formJson = formData?.post_treatment_json ? JSON.parse(formData.post_treatment_json) : null;
      filledFormData = formData?.filled_posttreatment_form_data || null;
      break;
    case 'Treatment Form':
      formJson = formData?.treatment_json ? JSON.parse(formData.treatment_json) : null;
      filledFormData = formData?.filled_treatment_form_data || null;
      break;
    default:
      console.warn('Invalid form type:', formType);
  }
  console.log("formJson",formJson)


  // useEffect(() => {
    
  //   if (formJson) {
  //     const defaultValues = {};

  //     formJson.forEach((field) => {
  //       if (nonEditableFields.includes(field.name)) {
          // if (LoginUserType === 'Patient') {
          //   if (field.name === 'patient_name' || field.name === 'fname_lname') {
          //     defaultValues[field.name] = `${LoginUserDetails.fname || ''} ${LoginUserDetails.lname || ''}`.trim();
          //   } else if (field.name === 'dob' || field.name === 'DOB') {
          //     defaultValues[field.name] = LoginUserDetails.DOB || '';
          //   } else if (field.name === 'zip' || field.name ==="postal_code") {
          //     defaultValues[field.name] = LoginUserDetails.postal_code || '';
          //   } else if (field.name === 'address' || field.name === "street") {
          //     defaultValues[field.name] = `${LoginUserDetails.street || ''}, ${LoginUserDetails.city || ''}, ${
          //       LoginUserDetails.state || ''
          //     } - ${LoginUserDetails.postal_code || ''}`.trim();
          //   } else if (field.name === 'date_signature' || field.name === 'date_representative_signature' || field.name ==="patient_date_of_signature") {
          //     defaultValues[field.name] = new Date().toISOString().split('T')[0]; // Current date
          //   } else {
          //     defaultValues[field.name] = LoginUserDetails[field.name] || '';
          //   }
          // } else {
          //   if (field.name === 'patient_name' || field.name === 'fname_lname') {
          //     defaultValues[field.name] = `${patientData?.fname || ''} ${patientData?.lname || ''}`.trim();
          //   } else if (field.name === 'dob' || field.name === 'DOB') {
          //     defaultValues[field.name] = patientData?.DOB || '';
          //   } else if (field.name === 'zip' || field.name ==="postal_code") {
          //     defaultValues[field.name] = patientData?.postal_code || '';
          //   } else if (field.name === 'address' || field.name === "street") {
          //     defaultValues[field.name] = `${patientData?.street || ''}, ${patientData?.city || ''}, ${
          //       patientData?.state || ''
          //     } - ${patientData?.postal_code || ''}`.trim();
          //   } else if (field.name === 'date_signature' || field.name === 'date_representative_signature' || field.name ==="patient_date_of_signature") {
          //     defaultValues[field.name] = new Date().toISOString().split('T')[0]; // Current date
          //   } else {
          //     defaultValues[field.name] = patientData?.[field.name] || '';
          //   }
          // }
  //       }
  //     });

  //     setFormValues(defaultValues);
  //   }
  // }, [ patientData, LoginUserDetails, LoginUserType,formJson]);

  useEffect(() => {
    if (!formJson) return;
  
    const defaultValues = {};
  
    formJson.forEach((field) => {
      if (nonEditableFields.includes(field.name)) {
        const newValue =
          LoginUserType === "Patient"
            ? field.name === "patient_name" || field.name === "fname_lname"
              ? `${LoginUserDetails.fname || ""} ${LoginUserDetails.lname || ""}`.trim()
              : field.name === "dob" || field.name === "DOB"
              ? LoginUserDetails.DOB || ""
              : field.name === "zip" || field.name === "postal_code"
              ? LoginUserDetails.postal_code || ""
              : field.name === "address" || field.name === "street"
              ? `${LoginUserDetails.street || ""}, ${LoginUserDetails.city || ""}, ${
                  LoginUserDetails.state || ""
                } - ${LoginUserDetails.postal_code || ""}`.trim()
              : field.name === "date_signature" ||
                field.name === "date_representative_signature" ||
                field.name === "patient_date_of_signature"
              ? new Date().toISOString().split("T")[0] // Current date
              : LoginUserDetails[field.name] || ""
            : field.name === "patient_name" || field.name === "fname_lname"
            ? `${patientData?.fname || ""} ${patientData?.lname || ""}`.trim()
            : field.name === "dob" || field.name === "DOB"
            ? patientData?.DOB || ""
            : field.name === "zip" || field.name === "postal_code"
            ? patientData?.postal_code || ""
            : field.name === "address" || field.name === "street"
            ? `${patientData?.street || ""}, ${patientData?.city || ""}, ${
                patientData?.state || ""
              } - ${patientData?.postal_code || ""}`.trim()
            : field.name === "date_signature" ||
              field.name === "date_representative_signature" ||
              field.name === "patient_date_of_signature"
            ? new Date().toISOString().split("T")[0] // Current date
            : patientData?.[field.name] || "";
    
        if (formValues[field.name] !== newValue) {
          defaultValues[field.name] = newValue;
        }
      }
    });
    
  
    if (Object.keys(defaultValues).length > 0) {
      setFormValues((prevValues) => ({ ...prevValues, ...defaultValues }));
    }
  }, [patientData, LoginUserDetails, LoginUserType, formJson]);
  

  const handleInputChange = (name, value) => {
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };
  const getFieldComponent = (field) => {
    const isDisabled = nonEditableFields.includes(field.name);

    switch (field.type) {
      case 'header':
        return (
          <Typography key={field.label} variant={field.subtype || 'h4'}>
            {field.label && /<\/?[a-z][\s\S]*>/i.test(field.label) ? (
              <span
                style={{ width: '100%' }}
                dangerouslySetInnerHTML={{ __html: field.label }}
              />
            ) : (
              field.label
            )}
          </Typography>
        );
      case 'text':
        return (
          <TextField
            key={field.label}
            fullWidth
            label={field.label}
            variant="outlined"
            type={field.subtype || 'text'}
            required={field.required}
            className={field.className}
            value={formValues[field.name] || ''}
            onChange={(e) => handleInputChange(field.name, e.target.value)}
            disabled={isDisabled}
            autoComplete="off"
          />
        );
      case 'textarea':
        return (
          <Box key={field.label}>
            <Typography variant="subtitle1">
              {field.label && /<\/?[a-z][\s\S]*>/i.test(field.label) ? (
                <span
                  style={{ width: '100%' }}
                  dangerouslySetInnerHTML={{ __html: field.label }}
                />
              ) : (
                field.label
              )}
            </Typography>
            <TextareaAutosize
              minRows={field.rows || 3}
              style={{ width: '100%', marginTop: 8 }}
              className={field.className}
              value={formValues[field.name] || ''}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              disabled={isDisabled}
              autoComplete="off"
            />
          </Box>
        );
      case 'checkbox-group':
        return (
          <FormControl key={field.label} component="fieldset" style={{ width: '100%' }}>
          <FormLabel component="legend">
            {field.label && /<\/?[a-z][\s\S]*>/i.test(field.label) ? (
              <span
                style={{ width: '100%' }}
                dangerouslySetInnerHTML={{ __html: field.label }}
              />
            ) : (
              field.label
            )}
          </FormLabel>
          {field.values.map((option, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={formValues[field.name]?.includes(option.value) || false}
                  onChange={(e) => {
                    setFormValues((prevValues) => {
                      const currentValues = prevValues[field.name] || [];
                      return {
                        ...prevValues,
                        [field.name]: e.target.checked
                          ? [...currentValues, option.value]
                          : currentValues.filter((val) => val !== option.value),
                      };
                    });
                  }}
                />
              }
              label={option.label}
            />
          ))}
        </FormControl>
        
        );
      case 'radio-group':
        return (
          <FormControl key={field.label} component="fieldset" style={{ width: '100%' }}>
            <FormLabel component="legend">
              {field.label && /<\/?[a-z][\s\S]*>/i.test(field.label) ? (
                <span
                  style={{ width: '100%' }}
                  dangerouslySetInnerHTML={{ __html: field.label }}
                />
              ) : (
                field.label
              )}
            </FormLabel>
            <RadioGroup
              value={formValues[field.name] || ''}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            >
              {field.values.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option.value}
                  control={<Radio />}
                  label={option.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        );
      case 'paragraph':
        return (
          <Typography key={field.label} variant="body1" dangerouslySetInnerHTML={{ __html: field.label }} />
        );
      case 'date':
        return (
          <TextField
            key={field.label}
            fullWidth
            label={field.label}
            variant="outlined"
            type="text"
            required={field.required}
            className={field.className}
            value={formValues[field.name] || ''}
            onChange={(e) => handleInputChange(field.name, e.target.value)}
            InputLabelProps={{ shrink: true }}
            disabled={isDisabled}
            autoComplete="off"
          />
        );
      default:
        return null;
    }
  };


  return (
    <Box sx={{ maxWidth: '100%', margin: 'auto', padding: 0 }}>
      {formJson?.map((field, index) => (
        <Box key={index} sx={{ marginBottom: 2 }}>
          {getFieldComponent(field)}
        </Box>
      ))}
      <Button variant="contained" color="primary">
        Submit
      </Button>
    </Box>
  );
};

export default ServicesForms;
